export default {
  methods: {
    showAuthModal() {
      window.modalStateObservable.isAuthModalActive = true;
    },
  },
};
